// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"_2Q-nf","fullScreenGallery":"jAYtZ","carImage":"_2W3re","comingSoonWrap":"_3N85T","comingSoonImg":"li7rE","bottomStrip":"_2hlSI"};